// extracted by mini-css-extract-plugin
module.exports = {"Header":"SignUpTemplate_Header__3IRxf","Wrapper":"SignUpTemplate_Wrapper__18DCy","Title":"SignUpTemplate_Title__2pzt-","Main":"SignUpTemplate_Main__tv_P7"};